module.exports = {
  API_HOST: process.env.VUE_APP_API_URL,
  API_SERVER_GAME: process.env.VUE_APP_API_SOCKET,
  API_SUFFIX: 'content',
};
